import { render, staticRenderFns } from "./AtendimentoItens.vue?vue&type=template&id=1a05c51a&"
import script from "./AtendimentoItens.vue?vue&type=script&lang=js&"
export * from "./AtendimentoItens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports